import { render, staticRenderFns } from "./lacrimalirrigation.vue?vue&type=template&id=56e18fef&scoped=true&"
import script from "./lacrimalirrigation.vue?vue&type=script&lang=js&"
export * from "./lacrimalirrigation.vue?vue&type=script&lang=js&"
import style0 from "./lacrimalirrigation.vue?vue&type=style&index=0&id=56e18fef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e18fef",
  null
  
)

export default component.exports